import React from 'react'

import {
  HeroSection,
  HeroItemsContainer,
  HeroTitle
} from './styles'

const Hero = ({ bannerSources, seoTitle }) => {
  return (
    <HeroSection sources={bannerSources}>
      <HeroItemsContainer sources={bannerSources}>
        <HeroTitle>{seoTitle}</HeroTitle>
      </HeroItemsContainer>
    </HeroSection>
  )
}

export default Hero
